// extracted by mini-css-extract-plugin
export default {"button-wrapper":"ProfileInfo_button-wrapper__2I-3V","link":"ProfileInfo_link__QmoIg"};